/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 查询该旗舰店是否被我关注
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class IsAttentionParams {
  constructor(public theaterId: string) {}
}

export default async function (
  params: IsAttentionParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/member/attention-exist`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
